import { Link } from 'react-router-dom';
import { PlateNumber } from '../ui/PlateNumber.jsx';
import { Badge } from '../ui/Badge.jsx';
import { UsageDot } from '../ui/UsageDot.jsx';
import { carsApi } from '../../api/cars.js';
import { expiryStatus } from '../../utils/dates.js';

// Agregează statusul cel mai urgent dintre documentele active.
function worstStatus(documents) {
  const priority = { expired: 4, danger: 3, warn: 2, ok: 1, null: 0 };
  let worst = null;
  for (const d of documents || []) {
    const s = expiryStatus(d.data_expirare);
    if (priority[s] > priority[worst]) worst = s;
  }
  return worst;
}

function StatusBadge({ status, docs }) {
  if (!status || status === 'ok') return null;
  const n = (docs || []).filter((d) => {
    const s = expiryStatus(d.data_expirare);
    return s === status || (status === 'danger' && s === 'expired');
  }).length;
  if (!n) return null;
  const map = {
    expired: { tone: 'danger', text: `${n} expirat${n > 1 ? 'e' : ''}` },
    danger: { tone: 'danger', text: `${n} în <7 zile` },
    warn: { tone: 'warn', text: `${n} în <30 zile` },
  };
  const m = map[status];
  return <Badge tone={m.tone}>{m.text}</Badge>;
}

export function CarCard({ car }) {
  const status = worstStatus(car.documents);
  const activeRentals = car._count?.rentals || 0;
  const photoUrl = car.poza_path ? carsApi.photoUrl(car.id) : null;

  return (
    <Link
      to={`/cars/${car.id}`}
      className="card flex gap-3 transition-transform hover:shadow-card-hover hover:-translate-y-0.5"
    >
      <div className="h-[72px] w-[72px] flex-shrink-0 overflow-hidden rounded-[14px] bg-cream">
        {photoUrl ? (
          <img src={photoUrl} alt="" className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-2xl text-border">⛃</div>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <PlateNumber value={car.numar_inmatriculare} size="md" />
          <StatusBadge status={status} docs={car.documents} />
        </div>
        <div className="mt-1.5 truncate text-sm font-medium text-ink">
          {car.marca} {car.model}
          {car.an && <span className="text-muted"> · {car.an}</span>}
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1">
          <UsageDot kind={car.tip_utilizare} />
          {car.kilometraj != null && (
            <span className="font-mono text-[11px] text-muted">{car.kilometraj.toLocaleString('ro-RO')} km</span>
          )}
          {activeRentals > 0 && (
            <span className="text-[11px] uppercase tracking-wider text-coral">Închiriată</span>
          )}
        </div>
        {car.assigned_to && (
          <div className="mt-1 text-[11px] text-muted">→ {car.assigned_to.name}</div>
        )}
      </div>
    </Link>
  );
}
